import type { State } from 'model/State';
import { postToHamsClient } from 'util/mac/api/creditCard/post';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';

type CCDataType = {
  gateway: string;
  gatewayCardExpiryDateMonth: number;
  gatewayCardExpiryDateYear: number;
  gatewayCardName: string;
  gatewayCardNumberMasked: string;
  gatewayCardScheme: string;
  paymentMethodId: string;
};

export const updateCCDetails = (accountId: number, creditCardData: CCDataType, state: State) =>
  fetchWithParamValidation(
    ({ id }) => postToHamsClient(`/${id}/updateCreditCardDetails`, state, {}, creditCardData),
    { id: accountId },
  );

export const enableAutoRenew = (accountId: number, creditCardData: CCDataType, state: State) =>
  fetchWithParamValidation(
    ({ id }) => postToHamsClient(`/${id}/enableAutoRenew`, state, {}, creditCardData),
    { id: accountId },
  );
